<template>
  <Modal ref="cadastro" title="Registrar novo perímetro" @cancel="closeModal">
    <div class="cadastro-container">
      <form class="main-form" @submit.prevent="registerPolygon">
        <Input
          legend="Nome do perímetro"
          placeholder="Digite o nome do perímetro"
          :modelValue="descricao"
          @update:modelValue="$event => (descricao = $event)"
          class="input-full"
        />

        <Button type="submit" color="primary" text="Salvar">
          <ContentSaveOutline :size="18" />
        </Button>
      </form>

      <div class="map-container">
        <div class="form-address">
          <div class="input-container">
            <legend>Buscar endereço do perímetro</legend>

            <input
              id="autocomplete-modal"
              type="text"
              class="input"
              v-model="search"
              placeholder="Digite o endereço do perímetro"
            />
          </div>
        </div>

        <div id="mapC" style="height: 500px"></div>
      </div>
    </div>

    <script async type="application/javascript">
      ;(g => {
        var h,
          a,
          k,
          p = 'The Google Maps JavaScript API',
          c = 'google',
          l = 'importLibrary',
          q = '__ib__',
          m = document,
          b = window
        b = b[c] || (b[c] = {})
        var d = b.maps || (b.maps = {}),
          r = new Set(),
          e = new URLSearchParams(),
          u = () =>
            h ||
            (h = new Promise(async (f, n) => {
              await (a = m.createElement('script'))
              e.set('libraries', [...r] + '')
              for (k in g)
                e.set(
                  k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()),
                  g[k]
                )
              e.set('callback', c + '.maps.' + q)
              a.src = `https://maps.${c}apis.com/maps/api/js?` + e
              d[q] = f
              a.onerror = () => (h = n(Error(p + ' could not load.')))
              a.nonce = m.querySelector('script[nonce]')?.nonce || ''
              m.head.append(a)
            }))
        d[l]
          ? console.warn(p + ' only loads once. Ignoring:', g)
          : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)))
      })({
        key: 'AIzaSyC5JcoGlTUPTGM_8GK9EKiPByA2WVZ2FKA',
        v: 'weekly',
        libraries: ['places'],
      })
    </script>
  </Modal>
  <!-- <vuestic-modal
    ref="cadastro"
    :cancelClass="'none'"
    :okClass="'none'"
    @closeEvent="closeModal"
    v-bind:large="true"
    :hide-overlay="true"
    :preventEsc="true"
  >
    
  </vuestic-modal> -->
</template>
<script>
import Button from 'core/Button'
import Input from 'core/Input'
import Modal from 'core/Modal'

import ContentSaveOutline from 'icons/ContentSaveOutline'
import Magnify from 'icons/Magnify'

export default {
  name: 'GoogleMap',
  components: {
    Modal,
    Input,
    Button,

    ContentSaveOutline,
    Magnify,
  },
  data() {
    return {
      map: null,
      poly: null,
      descricao: '',
      markers: [],
      coordinatesSelected: [],
      autocomplete: null,
      search: null,
    }
  },
  props: {
    CfcCoordinates: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    this.openModal()

    await this.initMap()
  },
  methods: {
    openModal() {
      this.$refs.cadastro.open()
    },
    closeModal() {
      this.descricao = ''
      this.search = ''
      this.$emit('close')
    },
    async initMap() {
      const { Map } = await google.maps.importLibrary('maps')

      const { lat, lng } = this.CfcCoordinates

      this.map = new Map(document.getElementById('mapC'), {
        center: { lat, lng },
        zoom: 15,
        mapId: 'cadastro',
      })

      this.poly = new google.maps.Polyline({
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 3,
      })

      this.poly.setMap(this.map)

      this.map.addListener('click', this.addLatLng)

      const input = document.getElementById('autocomplete-modal')

      this.autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ['geometry', 'formatted_address'],
        types: ['geocode'],
      })

      this.autocomplete.bindTo('bounds', this.map)

      this.autocomplete.addListener('place_changed', this.handlePlaceChanged)

      await this.sleep(2000)

      const pacContainers = document.querySelectorAll('.pac-container')
      pacContainers.forEach(pac => {
        pac.style.zIndex = '1052'
      })
    },
    handlePlaceChanged() {
      const place = this.autocomplete.getPlace()

      if (!place.geometry || !place.geometry.location) {
        console.error('Lugar inválido')
        return
      }

      const location = place.geometry.location

      this.search = place.formatted_address

      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport)
      } else {
        this.map.setCenter(location)
        this.map.setZoom(17)
      }

      if (this.marker) {
        this.marker.setMap(null)
      }

      this.marker = new google.maps.Marker({
        map: this.map,
        position: location,
        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      })
    },
    async addLatLng(event) {
      const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
      const latLng = event.latLng

      const existingMarkerIndex = this.coordinatesSelected.findIndex(
        coord => coord.lat === latLng.lat() && coord.lng === latLng.lng()
      )

      if (existingMarkerIndex !== -1) {
        this.markers[existingMarkerIndex].setMap(null)
        const path = this.poly.getPath()
        path.removeAt(existingMarkerIndex)
        this.markers.splice(existingMarkerIndex, 1)
        this.coordinatesSelected.splice(existingMarkerIndex, 1)
        return
      }

      this.coordinatesSelected.push({ lat: latLng.lat(), lng: latLng.lng() })
      const path = this.poly.getPath()
      path.push(latLng)

      const newMarker = new AdvancedMarkerElement({
        position: latLng,
        title: '#' + path.getLength(),
        map: this.map,
      })

      this.markers.push(newMarker)

      newMarker.addListener('click', () => {
        this.removeMarker(newMarker)
      })
    },
    removeMarker(marker) {
      marker.setMap(null)

      const index = this.markers.indexOf(marker)

      if (index > -1) {
        this.markers.splice(index, 1)
        this.coordinatesSelected.splice(index, 1)

        this.poly.getPath().removeAt(index)
      }
    },
    registerPolygon() {
      if (!this.descricao || !this.coordinatesSelected.length) {
        this.$toasted.show('Preencha todos os campos!', {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })
      }

      let data = {
        description: this.descricao,
        coordinates: this.coordinatesSelected,
      }

      this.$http
        .post(process.env.VUE_APP_URL_API_V2 + '/perimetros/create', data)
        .then(response => {
          this.closeModal()
        })
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
  },
}
</script>

<style lang="scss" scoped>
.cadastro-container {
  width: 70vw;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .main-form {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: flex-end;

    .input-full {
      flex: 1;
    }
  }

  .map-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .form-address {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      align-items: flex-end;

      .input-container {
        flex: 1;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        legend {
          margin: 0;
          font-size: 1rem;
          font-weight: 600;
          line-height: 21.82px;
          color: #606264;
        }

        .input {
          box-sizing: border-box;
          padding: 0.625rem;
          border: 1px solid #eaeaea;
          border-radius: 4px;
          outline: 0;
          font-size: 1rem;
          font-weight: 600;
          line-height: 21.82px;

          &::placeholder {
            color: #d3d3d3;
          }

          &:disabled {
            cursor: not-allowed;
          }

          &:-webkit-autofill {
            box-shadow: 0 0 0px 1000px white inset !important;
            -webkit-box-shadow: 0 0 0px 1000px white inset !important;
          }
        }
      }
    }
  }
}
</style>
